import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { CheckIsCodeExistsRequest, ImageEnum, ProductClient, ProductEnum, ProductRequest } from 'src/app/shared/api-connector/sso-connector';
import { AddCategoryDialogComponent } from '../add-category-dialog/add-category-dialog.component';
import { AddPositionDialogComponent } from '../add-position-dialog/add-position-dialog.component';
import { AddProductUnitDialogComponent } from '../add-product-unit-dialog/add-product-unit-dialog.component';
import { AddManufacturerDialogComponent } from '../add-manufacturer-dialog/add-manufacturer-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UploadService } from 'src/app/shared/services/upload.service';

@Component({
  selector: 'app-add-hang-hoa-dialog',
  templateUrl: './add-hang-hoa-dialog.component.html',
  styleUrls: ['./add-hang-hoa-dialog.component.scss']
})
export class AddHangHoaDialogComponent implements OnInit {
  myFormAddHangHoa = new FormGroup({
    codeCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateCodeNotTaken.bind(this)],
    }),
    barcodeCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateBarCodeNotTaken.bind(this)],
    }),
    titleCtrl: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'change',
      asyncValidators: [this.validateTitleNotTaken.bind(this)],
    }),
    abbreviationsCtrl: new FormControl('', {
      updateOn: 'change',
      asyncValidators: [this.validateAbbreviationsNotTaken.bind(this)],
    }),
    categoryCtrl: new FormControl('', [Validators.required]),
    bodyUsedCtrl: new FormControl(''),
    positionCtrl: new FormControl(''),
    priceCtrl: new FormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
    priceCostCtrl: new FormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
    weightCtrl: new FormControl(0),
    isHomepageCtrl: new FormControl(true),
    inventoryMaxCtrl: new FormControl(999999999),
    inventoryMinCtrl: new FormControl(0),
    descriptionCtrl: new FormControl(''),
    noteOrderCtrl: new FormControl(''),
    registrationNumberCtrl: new FormControl(''),
    hoatChatCtrl: new FormControl(''),
    hamLuongCtrl: new FormControl(''),
    packingCtrl: new FormControl(''),
    manufacturerCtrl: new FormControl(''),
    quocGiaCtrl: new FormControl(''),
    productUnitCtrl: new FormControl(''),
    hangHoaThanhPhanCtrl: new FormControl(''),
    inventoryCtrl: new FormControl(0)
  });

  isBatchExpireControl = false;
  ctrls = this.myFormAddHangHoa.controls;
  isLoadingAvatar: boolean;
  avatarId: string;
  lstImage = [];
  totalFile = 0;
  reloadCategoryComponent = null;
  reloadPositionComponent = null;
  reloadProductUnitComponent = null;
  reloadManufacturerComponent = null;
  @ViewChild('inputAvatar') $inputAvatar: ElementRef;
  scrollStrategy: ScrollStrategy;

  constructor(
    private productClient: ProductClient,
    private uploadService: UploadService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private readonly scrollStrategyOptions: ScrollStrategyOptions,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<AddHangHoaDialogComponent>,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
  }

  handleChange() {
    if (this.isBatchExpireControl) {
      this.ctrls.hangHoaThanhPhanCtrl.setValue('');
    }
  }

  close() {
    this.dialogRef.close();
    this.onReset();
  }

  onfocusInvalid() {
    for (const key of Object.keys(this.myFormAddHangHoa.controls)) {
      if (this.myFormAddHangHoa.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
        invalidControl.focus();
        break;
      }
    }
  }

  onSubmit() {
    this.myFormAddHangHoa.markAllAsTouched();
    this.onfocusInvalid();
    if (this.myFormAddHangHoa.valid) {
      this.spinner.show();
      this.productClient.createOrUpdate(new ProductRequest({
        abbreviations: this.ctrls.abbreviationsCtrl.value,
        barcode: this.ctrls.barcodeCtrl.value,
        bodyUsedId: this.ctrls.bodyUsedCtrl.value ? this.ctrls.bodyUsedCtrl.value.id : null,
        categoryId: this.ctrls.categoryCtrl.value ? this.ctrls.categoryCtrl.value.id : null,
        code: this.ctrls.codeCtrl.value,
        description: this.ctrls.descriptionCtrl.value,
        hamLuong: this.ctrls.hamLuongCtrl.value,
        hoatChat: this.ctrls.hoatChatCtrl.value,
        inventoryMax: this.ctrls.inventoryMaxCtrl.value,
        inventoryMin: this.ctrls.inventoryMinCtrl.value,
        isHomepage: this.ctrls.isHomepageCtrl.value,
        manufacturerId: this.ctrls.manufacturerCtrl.value ? this.ctrls.manufacturerCtrl.value.id : null,
        noteOrder: this.ctrls.noteOrderCtrl.value,
        packing: this.ctrls.packingCtrl.value,
        positionId: this.ctrls.positionCtrl.value ? this.ctrls.positionCtrl.value.id : null,
        quocGiaId: this.ctrls.quocGiaCtrl.value ? this.ctrls.quocGiaCtrl.value.id : null,
        registrationNumber: null,
        title: this.ctrls.titleCtrl.value,
        weight: this.ctrls.weightCtrl.value,
        type: ProductEnum.HangHoa,
        price: this.ctrls.priceCtrl.value,
        priceCost: this.ctrls.priceCostCtrl.value,
        lstImage: this.lstImage,
        productUnitId: this.ctrls.productUnitCtrl.value ? this.ctrls.productUnitCtrl.value.id : null,
        inventory: this.ctrls.inventoryCtrl.value
      }))
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.alertService.success('Thêm mới thuốc thành công', 'Thành công');
          this.dialogRef.close(this.ctrls.titleCtrl.value);
          this.onReset();
        });
    }
  }

  onReset() {
    this.myFormAddHangHoa.reset();
    setTimeout(() => {
      this.ctrls.isHomepageCtrl.setValue(true);
      this.ctrls.priceCtrl.setValue(0);
      this.ctrls.priceCostCtrl.setValue(0);
      this.ctrls.inventoryMaxCtrl.setValue(999999999);
      this.ctrls.inventoryMinCtrl.setValue(0);
      this.ctrls.weightCtrl.setValue(0);
    }, 300);
  }

  addManufacturer() {
    const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadManufacturerComponent = x;
      }
    });
  }

  addProductUnit() {
    const dialogRef = this.dialog.open(AddProductUnitDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadProductUnitComponent = x;
      }
    });
  }

  addPosition() {
    const dialogRef = this.dialog.open(AddPositionDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        this.reloadPositionComponent = x;
      }
    });
  }

  addCategoryDialog() {
    const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
      panelClass: 'custom-dialog',
      minWidth: '500px',
      disableClose: true,
      scrollStrategy: this.scrollStrategy
    });

    dialogRef.afterClosed().subscribe(x => {
      if (x) {
        // this.onSearch();
        this.reloadCategoryComponent = x;
      }
    });
  }

  getUrlFile(id: string) {
    return this.uploadService.getUrlFile(id);
  }

  removeImage(imageId) {
    this.lstImage = this.lstImage.filter(x => x != imageId);
    this.totalFile = this.lstImage.length;
  }

  onMultipeFileChange(event) {
    var filesAmount = event.target.files.length;
    if (filesAmount > 5) {
      this.alertService.error("Không vượt quá 5 file", "Lỗi upload file");
      return;
    }
    this.totalFile = filesAmount;
    this.lstImage = [];
    if (filesAmount === 0) {
      return;
    }
    if (event.target.files && event.target.files[0]) {
      this.uploadService
        .uploadMultipeFile(event.target.files, 0, ImageEnum.None)
        .pipe(finalize(() => (this.isLoadingAvatar = false)))
        .subscribe((x: any) => {
          x.forEach((element) => {
            this.lstImage.push(element.Id);
          });
        });
    }
  }

  validateCodeNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsCodeExists(new CheckIsCodeExistsRequest({
        code: this.ctrls.codeCtrl.value,
      })).pipe(
        map(res => {
          return res ? { codeTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateBarCodeNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsBarCodeExists(new CheckIsCodeExistsRequest({
        code: this.ctrls.barcodeCtrl.value,
      })).pipe(
        map(res => {
          return res ? { barcodeTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateTitleNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsTitleExists(new CheckIsCodeExistsRequest({
        code: this.ctrls.titleCtrl.value,
      })).pipe(
        map(res => {
          return res ? { titleTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  validateAbbreviationsNotTaken(control: FormControl): any {
    if (control.value) {
      return this.productClient.checkIsTitleExists(new CheckIsCodeExistsRequest({
        code: this.ctrls.abbreviationsCtrl.value,
      })).pipe(
        map(res => {
          return res ? { abbreviationsTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

}
